import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { INewsBroadcastInput } from "models/news";
import newsBroadcastValidator from "validators/broadcast/newsBroadcast.validator";
import { newsBroadcastApi } from "api/broadcast";
import { useNotificationContext } from "contexts/NotificationContext";
import { useNavigate } from "react-router-dom";
import { RouteName } from "constants/route";

export default function useNewsBroadcast() {
  const { showError, showSuccess } = useNotificationContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const { control, handleSubmit, watch } = useForm<INewsBroadcastInput>({
    resolver: yupResolver(newsBroadcastValidator),
    defaultValues: {
      driver_age: [20, 50],
      fleet_production_year: [2004, 2020],
    },
  });
  const watchTo = watch("to");

  const onSubmit = async (input: INewsBroadcastInput) => {
    setLoading(true);
    console.log("📢 Broadcasting news with data:", {
      title: input.title,
      to: input.to,
      driver_age: input.driver_age,
      fleet_production_year: input.fleet_production_year,
      content_length: input.content?.length,
    });

    const { data, error } = await newsBroadcastApi(input);
    if (data) {
      console.log("✅ News broadcast API response:", data);
      console.log("📱 Backend should send socket notification to:", input.to);
      showSuccess("News broadcasted Successfully");
      navigate(RouteName.NEWS, { replace: true });
    } else {
      console.error("❌ News broadcast API error:", error);
      showError(error!.message);
    }

    setLoading(false);
  };

  return { handleSubmit, onSubmit, control, loading, watchTo };
}
